import { DataBean } from "../DataBean";

export class ScheduleMaintenance extends DataBean {

  public async getScheduleMaintenanceCatalogPorPropiedades( properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getScheduleMaintenanceCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getScheduleMaintenanceRender( page: number, rows: number, properties: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getScheduleMaintenanceRender_Number_Number_java.util.Map",
      [ page, rows, properties]
    );
  }

  public async deleteScheduleMaintenance(idschedulemaintenance: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deleteScheduleMaintenance_Number",
      [idschedulemaintenance]
    );
  }

  public async confirmScheduleMaintenance(bean: any) : Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.TechnicianAssignment_confirmScheduleMaintenance_java.util.Map",
      [bean]
    )
  }

  public async updateScheduleMaintenance(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.ScheduleMaintenance_updateScheduleMaintenance_com.orange.finance.processcontract.bean.ScheduleMaintenance",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.ScheduleMaintenance",
        },
      ]
    );
  }
}
